var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounPlane4216230222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1110.4,600c0-40.8-35.8-76.6-76.6-76.6H753.2L497.9,115.1H395.8l127.6,408.4l-280.5,0l-76.6-102.1H89.7 l51,178.7l-51,178.7h76.6l76.6-102.1h280.7l-127.6,408.4H498l255.2-408.4H1034C1074.7,676.6,1110.4,640.8,1110.4,600L1110.4,600z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPlane4216230222222);
export default __webpack_public_path__ + "static/media/noun-plane-4216230-222222.809fbcee1a1c99cf127d890ee74d855b.svg";
export { ForwardRef as ReactComponent };